import { useQuery, ApolloError } from '@apollo/client'

import { ME } from '@libs/apollo/queries'

import { User } from '@types'

interface Data {
  me: User
}

export const useMe = (): {
  loading: boolean
  error: ApolloError | undefined
  data?: Data
  refetch: () => void
  getMe: () => User
} => {
  const { loading, error, data, refetch } = useQuery<Data>(ME, { notifyOnNetworkStatusChange: true })

  const _refetch = () => {
    refetch()
  }

  const getMe = (): User => {
    if (!data?.me) {
      throw new Error('"getMet" function must be used in child Component tree of "withUserGuard"')
    }

    return data.me
  }

  return { loading, error, data, refetch: _refetch, getMe }
}
